import {ModaleLayout} from '@/components/Modale/ModaleLayout';
import {ProduitPanierErrorCommun} from '@/domains/panier/PanierFound/ProduitPanier/ProduitPanierErrorCommun';
import {dateAvecSlashes} from 'ff-common';
import NiceModal from '@ebay/nice-modal-react';
import {HaliRenderAll} from '@synako/haligator';
import {FollowPromiseOne, State} from '@synako/halitrek';
import {
  DisponibiliteArticleDesc,
  LigneDePanierDesc,
} from 'api-types/ffconnect-hal';
import {useTranslation} from 'react-i18next';

export interface ModaleErreurDisponibiliteProps {
  dispo: State<DisponibiliteArticleDesc>;
  ligneDePanier: FollowPromiseOne<LigneDePanierDesc>;
  date_de_livraison?: string;
  onProductClick?: (code_article: string) => void;
}

export const ModaleErreurDisponibilite = NiceModal.create(
  ({
    dispo,
    ligneDePanier,
    date_de_livraison,
    onProductClick,
  }: ModaleErreurDisponibiliteProps) => {
    const {t} = useTranslation();
    const modal = NiceModal.useModal();

    const clearAndClose = () => {
      modal.remove();
    };

    return (
      <ModaleLayout
        visible={modal.visible}
        hide={clearAndClose}
        titre={
          date_de_livraison
            ? t('ligne_produit.indisponible.produit_indisponible', {
                dateDeLivraison: dateAvecSlashes(date_de_livraison),
              })
            : t('ligne_produit.indisponible.produit_indisponible_short')
        }
      >
        <HaliRenderAll
          all={[ligneDePanier, ligneDePanier.follow('item_2')]}
          render={({states: [ligneDePanierState, itemState]}) => {
            if (!ligneDePanierState) return;
            return (
              <ProduitPanierErrorCommun
                context='modale'
                dispo={dispo}
                idError='error'
                ligneDePanier={ligneDePanierState}
                onClose={clearAndClose}
                multipleCommandeClient={
                  itemState?.data.multiple_de_commande_client
                }
                onProductClick={onProductClick}
                itemState={itemState}
              />
            );
          }}
        />
      </ModaleLayout>
    );
  },
);
